import { ParsedUrlQuery } from "querystring";
import { Variant } from "@/types/types.ts";
import type { UrlObject } from "url";
import { filterQueryParams } from "@/utils/url/filterQueryParams";

export function createSelectedSizeUrlObj(
  targetVariant: Variant,
  query: ParsedUrlQuery,
): UrlObject {
  const queryParams = filterQueryParams(query);

  return {
    pathname: targetVariant.pdpURL.path,
    query: { ...queryParams, size: targetVariant.pdpURL.query?.size },
  };
}
